import { render, staticRenderFns } from "./InviteDetailInfos.vue?vue&type=template&id=b03f0eb2"
import script from "./InviteDetailInfos.vue?vue&type=script&lang=js"
export * from "./InviteDetailInfos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports